import { createTheme } from "@mui/material/styles";
const theme = (data: any) => {
  const palette = {
    primary: {
      main: data?.PRIMARY_COLOR || "#31accd",
      contrastText: "#fff",
    },
    secondary: {
      main: data?.SECONDARY_COLOR || "#686666",
    },
    light: {
      main: data?.LIGHT_COLOR || "#e7e7e7",
    },
    dark: {
      main: data?.DARK_COLOR || "#040404",
      sub: "#000000"
    },
    highlight: {
      main: data?.PRIMARY_COLOR || "#31accd",
    },
  };

  return createTheme({
    palette,
    typography: {
      fontFamily: [data?.FONT_NAME || "Jost", "sans-serif"].join(","),
      fontSize: 10,
      htmlFontSize: 10,
    },
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: 18,
            marginBottom: 8,
            color: palette.dark.main,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: 15,
            "& ::placeholder": {
              fontSize: 14,
              fontWeight: 400,
            },
            "& .Mui-disabled.MuiInputBase-input": {
              cursor: "no-drop !important",
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: 10,
            boxShadow: "none",
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          root: {
            boxShadow: "none",
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: palette.light.main,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "6px",
            border: 0,
            boxShadow: "none",
            textTransform: "none",
            "&.Mui-disabled": {
              opacity: 1,
              cursor: "no-drop !important",
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            fontSize: 10,
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            fontSize: 10,
            "&:last-child td, &:last-child th": {
              border: 0,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: 16,
            fontWeight: 600,
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontSize: 10,
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            fontSize: 10,
          },
          option: {
            fontSize: 16,
          },
          noOptions: {
            fontSize: 10,
          },
        },
      },
    },
  });
};

export default theme;
